import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import "./css/common.css";
import Header from "./components/Header";
import useContent from "./Utils/useContent";
import ScrollToTop from "react-scroll-up";
import React, { useEffect, useState, lazy, Suspense } from "react";
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import nameReducer from './store/reducers';
import productData from "./includes/LoanProducts.json";
import WhlPageWrapper from "./components/WhlPageWrapper";
import { CookieSetting } from "cookiesetting-component";
const Footer = lazy(() => import('./components/FooterNew/index'));
const renderLoader = () => <p>Loading...</p>;

const AppWrapper = () => {
  const store = createStore(nameReducer);

  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

function App() {

  const [pageDetails, setPageDetails] = useState({
    pageName: '',
    loanProduct: ''
  })
  const [showOtherComponents, setShowOtherComponents] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState('Spanish');

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  const contentData = useContent(selectedLanguage);

  // Handle Scroll to show other components
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    };

    const debouncedHandleScroll = debounce(handleScroll, 100); // debounce to limit scroll handler calls
    window.addEventListener('scroll', debouncedHandleScroll);

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
    };
  }, []);

  // Debounce function to limit function calls
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  const loadWHLPageDetails = () => {
    // read env and make prop 'page' to be passed to diffnt pages

    // To get React App URL
    let loanProduct = `${process.env.REACT_APP_URL}`;

    //-- to get programe name
    const programName = productData[loanProduct].programName;
    const programDetails = productData[loanProduct];

    setPageDetails(state => {
      return {
        ...state,
        pageName: programName,
        loanProduct: loanProduct,
        programDetails: programDetails
      }
    })

  }

  useEffect(() => {
    loadWHLPageDetails()
  }, [])

  if (process.env.REACT_APP_TITLE === 'Chenoa DPA') {
    return <>
      <div className="App revamp">
        <Router basename={process.env.PUBLIC_URL}>
          <WhlPageWrapper pageDetails={pageDetails} />
        </Router>

        <ScrollToTop showUnder={160} style={{ transitionDuration: "0.6s" }}>
          <span className="back-to-top"></span>
        </ScrollToTop>
      </div>
    </>
  }
  if (contentData === null) {
    return (<p>Loading...</p>)
  }

  return (
    <div>
      <div className="App">
        <Router basename={process.env.PUBLIC_URL}>
          <Header onLanguageChange={handleLanguageChange} data={contentData} props={contentData} />
          <WhlPageWrapper pageDetails={pageDetails} data={contentData} props={contentData} />
        </Router>
      </div>
      {showOtherComponents && (
        <>
          <Suspense fallback={renderLoader()}>
            <Footer pageDetails={pageDetails} data={contentData} />
          </Suspense>
          <CookieSetting
            privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
            configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
            analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
        </>
      )}
      <ScrollToTop showUnder={160} style={{ transitionDuration: "0.6s" }}>
        <span className="back-to-top"></span>
      </ScrollToTop>
    </div>
  );
}

export default AppWrapper;
